import React from 'react'
import format from 'civic-champs-shared/utils/format'
import { useCurrentDateWithFilename } from 'components/table/ExportCsvMenuItem'
import { ExportButton } from 'core/table/components'

const filename = 'organizations.csv'
const headers = [
  { label: 'Name', key: 'name' },
  { label: 'Address', key: 'address' },
  { label: 'Description', key: 'description' },
  { label: 'Website', key: 'website' },
  { label: 'Created at', key: 'createdAt' },
  { label: 'SMS Credits', key: 'smsCredits' },
  { label: 'Email Credits', key: 'emailCredits' },
  { label: 'Future Event Visibility In Days', key: 'futureEventVisibilityDays' },
  { label: 'Reply Email', key: 'replyToEmail' },
  { label: 'Total Members', key: 'totalMembers' },
  { label: 'Total Volunteers', key: 'totalVolunteers' },
  { label: 'Total Hours Volunteered', key: 'totalHoursVolunteered' },
  { label: 'Total Activities', key: 'totalActivities' },
]

const formatData = (organizations: any[]) => {
  return organizations.map(({ original }) => ({
    ...original,
    createdAt: format.date(original.createdAt),
    address: format.address(original.address),
    totalHoursVolunteered: format.fixedPoint(original.totalHoursVolunteered, 1),
  }))
}

const ExportOrganizationsButton = ({ data, disabled }: { data: any[]; disabled?: boolean }) => {
  const filteredHeaders = headers
  const fileNameWithDate = useCurrentDateWithFilename(filename)

  return (
    <ExportButton
      data={data}
      formatData={formatData}
      headers={filteredHeaders}
      disabled={disabled}
      filename={fileNameWithDate as string}
    />
  )
}

export default ExportOrganizationsButton
